import { render, staticRenderFns } from "./eliminationList.vue?vue&type=template&id=22be65de&scoped=true&"
import script from "./eliminationList.vue?vue&type=script&lang=js&"
export * from "./eliminationList.vue?vue&type=script&lang=js&"
import style0 from "./eliminationList.vue?vue&type=style&index=0&id=22be65de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be65de",
  null
  
)

export default component.exports